import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FalconCloseButton from 'components/common/FalconCloseButton';
import { Link } from 'react-router-dom';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import CurrencyInput from 'react-currency-input-field';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';

const ModalConciliarPago = ({
    showModalConciliar,
    setShowModalConciliar,
    idPago,
    onPagoActualizado
}) => {
    const { token, setToken, idCatTipoUsuario } = useToken();
    const [Modal_idCatMedioPago, setModal_idCatMedioPago] = useState('');
    const [Modal_dTipoCambio, setModal_dTipoCambio] = useState('1.0000');
    const [Modal_idCatFormaPago, setModal_idCatFormaPago] = useState('');
    const [Modal_idCatCuentaBancaria, setModal_idCatCuentaBancaria] = useState('');
    const [Modal_vReferencia, setModal_vReferencia] = useState('');
    const [CargandoModalConciliar, setCargandoModalConciliar] = useState(true);
    const [StateEditarModal, setStateEditarModal] = useState(false);
    const [EsConciliado, setEsConciliado] = useState(false);
    const [monedaEditada, setMonedaEditada] = useState('');
    const { showErrorToast, showSuccessToast } = useToast();

    const [ordenObj, setOrdenObj] = useState({});
    const [FechaPago, setFechaPago] = useState('');
    const [NotasInputText, setNotasInputText] = useState('');

    const [cuentas, setCuentas] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [showCancelarPagoModal, setShowCancelarPagoModal] = useState(false);
    const [motivoCancelacionPago, setMotivoCancelacionPago] = useState('');
    const [procesandoCancelacion, setProcesandoCancelacion] = useState(false);


    /**
     * Obtiene el catálogo de monedas
     */
    const ObtenerCatMonedas = async () => {
        const response = await fetch("/api/Facturas/ObtenerCatMonedas", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setMonedas(ObjDetalles.table2 || []);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
    * Obtiene el pago por Identificador numerico
    */
    const obtenerPagoByIDPago = async () => {
        setStateEditarModal(false);
        setCargandoModalConciliar(true);
        const response = await fetch("/api/conciliacion/obtenerPagoPorID/?idPago=" + idPago,
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);

                console.log(data);
                var pago_ = data['table1'][0];

                let parsedJson = {};
                if (pago_.vJsonDetallesLinkPago && pago_.vJsonDetallesLinkPago !== "undefined") {
                    parsedJson = JSON.parse(pago_.vJsonDetallesLinkPago);
                }

                pago_.objDataExtra = parsedJson;

                setOrdenObj(pago_);
                setMonedaEditada(data['table1'][0].vMoneda);
                setModal_idCatMedioPago(data['table1'][0].idCatMedioPago);
                setModal_idCatFormaPago(data['table1'][0].idCatFormaPago);
                setModal_idCatCuentaBancaria(data['table1'][0].idCatCuentaBancaria);
                setModal_vReferencia(data['table1'][0].vReferencia);

                setModal_dTipoCambio(data['table1'][0].dTipoCambio);

                setFechaPago(new Date(data['table1'][0].dFechaPago));
                setNotasInputText(data['table1'][0].vNotasConciliacion);
                setEsConciliado(data['table1'][0].bIsFacturado);

                setCuentas(data['table2']);
                setMediosPago(data['table3']);
                setFormasPago(data['table4']);

            } else {

                setShowModalConciliar(false);

                showErrorToast(responseType.vMessage);
                //console.log(response);
            }

        }
        else {
            setShowModalConciliar(false);


            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargandoModalConciliar(false);


    }

    /**
     * Gaurda la conciliacion
     */
    const onSubmitConciliacion = async (flagConciliar) => {

        var data = {};

        data.Notas = (NotasInputText == null) ? "" : NotasInputText;
        //data.dFechaPago = FechaPago;
        data.dFechaPago = new Date(FechaPago).toISOString();
        data.idPago = ordenObj.idPago;

        console.log(JSON.stringify(data));

        setCargandoModalConciliar(true);

        const response = await fetch("/api/conciliacion/Conciliar/?notas=" + data.Notas + /*"&fechaPago=" + data.dFechaPago +*/ "&idPago=" + data.idPago + "&flagConciliar=" + flagConciliar, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);


                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                obtenerPagoByIDPago(ordenObj.idPago);

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido " + (flagConciliar == "1" ? "Conciliado" : "Desconciliado"));

                if (onPagoActualizado) onPagoActualizado();

                //ObtenerPagos();

            } else {

                showErrorToast(responseType.vMessage);


            }

            setCargandoModalConciliar(false);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);


            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);

        }

    };

    /**
     * Maneja la función para activar el pago si esta desactivado
     */    const handdleActivarPago = async (data) => {
        if (data === "0") {
            setShowCancelarPagoModal(true);
            return;
        }

        await procesarActivarPago("1", "");
    };

    const confirmarCancelacionPago = async () => {
        if (!motivoCancelacionPago.trim()) {
            showErrorToast('Debe ingresar un motivo para cancelar el pago.');
            return;
        }
        setProcesandoCancelacion(true);
        await procesarActivarPago("0", motivoCancelacionPago);
        setProcesandoCancelacion(false);
        setShowCancelarPagoModal(false);
    };

    const procesarActivarPago = async (data) => {
        setShowModalConciliar(true);
        setCargandoModalConciliar(true);

        const response = await fetch("/api/conciliacion/activaPago/?idPago=" + ordenObj.idPago + "&bIsActive=" + data, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido " + ((data == "1") ? "Activado" : "Cancelado"));

                if (onPagoActualizado) onPagoActualizado();

                reset();
                obtenerPagoByIDPago(ordenObj.idPago);

                setCargandoModalConciliar(false);

            } else {


                showErrorToast(responseType.vMessage);
                setCargandoModalConciliar(false);
            }
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);
        }

    }


    /**
     * Edita caracteristicas del pago
     * @param {any} vMoneda_
     * @param {any} dTipoCambio_
     * @param {any} idCatMedioPago_
     * @param {any} idCatFormaPago_
     * @param {any} idCatCuentaBancaria_
     * @param {any} FechaPago_
     * @param {any} vReferencia_
     */
    const handdleEditarPago = async (vMoneda_, dTipoCambio_, idCatMedioPago_, idCatFormaPago_, idCatCuentaBancaria_, FechaPago_, vReferencia_) => {
        var data = {};

        data.idPago = ordenObj.idPago;
        data.vMoneda = (vMoneda_ == null) ? "" : vMoneda_;
        data.dTipoCambio = dTipoCambio_;
        data.idCatMedioPago = (idCatMedioPago_ == 0 || idCatMedioPago_ == null) ? "" : idCatMedioPago_;
        data.idCatFormaPago = (idCatFormaPago_ == 0 || idCatFormaPago_ == null) ? "" : idCatFormaPago_;
        data.idCatCuentaBancaria = (idCatCuentaBancaria_ == 0 || idCatCuentaBancaria_ == null) ? "0" : idCatCuentaBancaria_;
        data.vReferencia = (vReferencia_ == null) ? "" : vReferencia_;
        data.dFechaPago = new Date(FechaPago_).toISOString();

        if (!ordenObj.objDataExtra.vCardType) {
            ordenObj.objDataExtra.vCardCompany = null;
        }

        data.vJsonDetallesLinkPago = encodeURIComponent(JSON.stringify(ordenObj.objDataExtra));
        console.log(JSON.stringify(data));

        setCargandoModalConciliar(true);

        const response = await fetch("/api/conciliacion/editarPago/?idPago=" + data.idPago + "&vMoneda=" + data.vMoneda +
            "&dTipoCambio=" + data.dTipoCambio + "&idCatMedioPago=" + data.idCatMedioPago + "&idCatFormaPago=" + data.idCatFormaPago +
            "&dFechaPago=" + data.dFechaPago + "&idCatCuentaBancaria=" + data.idCatCuentaBancaria + "&vReferencia=" + data.vReferencia + "&vJsonDetallesLinkPago=" + data.vJsonDetallesLinkPago + "&vNotas=" + encodeURIComponent(NotasInputText || ''), {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                setStateEditarModal(false);
                obtenerPagoByIDPago(ordenObj.idPago);

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido editado correctamente");

                if (onPagoActualizado) onPagoActualizado();


                //ObtenerPagos();

            } else {


                showErrorToast(responseType.vMessage);
            }

            setCargandoModalConciliar(false);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);

        }

    }

    useEffect(() => {
        obtenerPagoByIDPago();
        ObtenerCatMonedas();
    }, [])

    /**
     * Hace reset a los estados
     */
    const reset = async () => {
        setOrdenObj({});
        setNotasInputText('');
        setFechaPago('');
        setEsConciliado(false);
    }


    return (
        <Modal
            show={showModalConciliar}
            onHide={() => { setShowModalConciliar(false); reset() }}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form noValidate>
                {(!ordenObj.bIsActive && !CargandoModalConciliar) &&
                    <Alert key={"danger"} variant={"danger"} className="m-0 rounded-0 d-flex align-items-center justify-content-between p-2 px-3">
                        <div>El pago esta <strong>Cancelado 🚫</strong></div>
                        {idCatTipoUsuario == 1 &&
                            <Button variant='primary' className="fs--2 m-0 p-1 px-2" size="sm" onClick={() => { handdleActivarPago("1") }}>Activar Pago</Button>
                        }
                    </Alert>
                }
                {EsConciliado && !CargandoModalConciliar && (
                    <Alert key={"success"} variant={"success"} className="m-0 rounded-0 d-flex align-items-center justify-content-between p-2 px-3">
                        <div>
                            El pago está <strong>Conciliado</strong>.&nbsp;&nbsp; | &nbsp;&nbsp; Conciliado por <strong className="">{ordenObj.vUsuarioConciliador}</strong> el <strong className="">{new Date(ordenObj.dFechaConciliacion).toLocaleDateString('es-mx', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}</strong>
                        </div>
                        {idCatTipoUsuario == 1 && !StateEditarModal &&
                            <Button variant='danger' className="fs--2 m-0 p-1 px-2" size="sm" onClick={() => { onSubmitConciliacion("0"); }}>Desconciliar</Button>
                        }
                    </Alert>
                )}

                <Modal.Header className="border-bottom pb-3">
                    <div className="d-flex justify-content-between w-100 align-items-start">
                        <div>
                            <Modal.Title className="d-flex align-items-center gap-2 mb-1">
                                {CargandoModalConciliar ? <Skeleton width={150} /> : (
                                    <span className="fw-bolder fs-1 text-uppercase text-700">Detalle del Pago #{ordenObj.idPago}</span>
                                )}
                            </Modal.Title>
                            <h3 className="fw-bolder mb-1 text-primary">
                                {CargandoModalConciliar ? <Skeleton width={100} /> : (
                                    <>
                                        {ordenObj.dImportePago?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        <span className="fs-0 fw-semi-bold text-500 ms-1">{ordenObj.vMoneda}</span>
                                        {ordenObj.vMoneda != "MXN" && <span className="fs--1 ms-2 text-500">T.C. {parseFloat(ordenObj.dTipoCambio || 1).toFixed(4)}</span>}
                                    </>
                                )}
                            </h3>
                            {!CargandoModalConciliar && (
                                <>
                                    <div className="fs--1 text-600 mb-1">
                                        {ordenObj.dFechaPago ? new Date(ordenObj.dFechaPago).toLocaleDateString('es-mx', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : ''} | Orden <Link to={`/ordenes/detalle/${ordenObj.idOrden}`} target="_blank" className="text-primary text-decoration-none cursor-pointer">#{ordenObj.idOrden}</Link>
                                    </div>
                                    <div className="fs--2 text-500 text-uppercase mb-2">
                                        Vendedor<br />
                                        <span className="fw-bold text-700">{ordenObj.vNombreVendedor || "NO ESPECIFICADO"}</span>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Badge bg={ordenObj.bIsActive == 1 ? "success-subtle" : "danger-subtle"} text={ordenObj.bIsActive == 1 ? "success" : "danger"} pill className="fs--2 fw-bold px-3 py-1 d-flex align-items-center gap-1 border border-1 border-opacity-10">
                                            {ordenObj.bIsActive == 1 ? "ACTIVO" : "CANCELADO"} {ordenObj.bIsActive == 1 ? <FontAwesomeIcon icon={icon({ name: 'check', style: "solid" })} className="ms-1" /> : <FontAwesomeIcon icon={icon({ name: 'xmark', style: "solid" })} className="ms-1" />}
                                        </Badge>
                                        <Badge bg={ordenObj.idCatCuentaBancaria > 0 ? "success-subtle" : "danger-subtle"} text={ordenObj.idCatCuentaBancaria > 0 ? "success" : "danger"} pill className="fs--2 fw-bold px-3 py-1 d-flex align-items-center gap-1 border border-1 border-opacity-10">
                                            {ordenObj.idCatCuentaBancaria > 0 ? "VALIDADO" : "NO VALIDADO"} {ordenObj.idCatCuentaBancaria > 0 ? <FontAwesomeIcon icon={icon({ name: 'check', style: "solid" })} className="ms-1" /> : <FontAwesomeIcon icon={icon({ name: 'xmark', style: "solid" })} className="ms-1" />}
                                        </Badge>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="d-flex align-items-center gap-2 mt-1">
                            {ordenObj.bIsActive == 1 && idCatTipoUsuario == 1 && (
                                <Button variant="outline-danger" size="sm" className="d-flex align-items-center gap-1 rounded px-2 fw-semi-bold border shadow-none" onClick={() => setShowCancelarPagoModal(true)}>
                                    <FontAwesomeIcon icon={icon({ name: 'circle-xmark', style: "regular" })} /> Cancelar Pago
                                </Button>
                            )}
                            {!CargandoModalConciliar && (
                                <Button
                                    variant={StateEditarModal ? "primary" : "light"}
                                    size="sm"
                                    className="d-flex align-items-center gap-2 rounded px-3 fw-semi-bold border shadow-none"
                                    onClick={() => setStateEditarModal(!StateEditarModal)}
                                >
                                    {StateEditarModal ? <FontAwesomeIcon icon={icon({ name: 'eye', style: "solid" })} className="fs--2" /> : <FontAwesomeIcon icon={icon({ name: 'pen', style: "solid" })} className="fs--2" />}
                                    {StateEditarModal ? "Ver Datos" : "Editar"}
                                </Button>
                            )}
                            {CargandoModalConciliar ? <Skeleton circle width={24} height={24} /> :
                                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0 ms-2" onClick={() => { setShowModalConciliar(false); reset() }} />
                            }
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="pt-3">

                    {!StateEditarModal ? (
                        /* LECTURA MODE */
                        <Row className="mb-4">
                            <Col md={6}>
                                <h6 className="text-600 fw-bold fs--2 text-uppercase mb-3 mt-1">INFORMACIÓN DEL PAGO</h6>
                                <hr className="bg-200 mb-3" style={{ opacity: 0.5 }} />

                                <div className="mb-3">
                                    <div className="text-500 fs--2 fw-semi-bold mb-1">Moneda</div>
                                    <div className="fw-bold text-dark fs--1">{CargandoModalConciliar ? <Skeleton /> : ordenObj.vMoneda}</div>
                                </div>
                                <div className="mb-3">
                                    <div className="text-500 fs--2 fw-semi-bold mb-1">Forma de Pago</div>
                                    <div className="fw-bold text-dark fs--1">{CargandoModalConciliar ? <Skeleton /> : formasPago.find(f => f.idCatFormaPago == ordenObj.idCatFormaPago)?.vDescripcionFormaPago || "Sin Especificar"}</div>
                                </div>
                                <div>
                                    <div className="text-500 fs--2 fw-semi-bold mb-1">Referencia de Transacción</div>
                                    <div className="fw-bold text-dark d-flex align-items-center gap-2">
                                        {CargandoModalConciliar ? <Skeleton width={150} /> : (
                                            <>
                                                <span className="badge bg-light text-primary px-2 py-1 fs--1 border">{ordenObj.vReferencia || "SIN REFERENCIA"}</span>
                                                <FontAwesomeIcon icon={icon({ name: 'copy', style: "regular" })} className="text-400 cursor-pointer hover-text-600" onClick={() => { navigator.clipboard.writeText(ordenObj.vReferencia); showSuccessToast("Referencia copiada"); }} />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col md={6} className="ps-md-4">
                                <h6 className="text-600 fw-bold fs--2 text-uppercase mb-3 mt-1">DETALLES DEL MEDIO</h6>
                                <hr className="bg-200 mb-3" style={{ opacity: 0.5 }} />

                                <div className="mb-3">
                                    <div className="text-500 fs--2 fw-semi-bold mb-1">Método de Pago</div>
                                    <div className="fw-bold text-dark d-flex align-items-center gap-2 fs--1">
                                        {CargandoModalConciliar ? <Skeleton /> : (
                                            <>
                                                <FontAwesomeIcon icon={icon({ name: 'stripe-s', style: "brands" })} className="text-primary fs-1" />
                                                {mediosPago.find(m => m.idCatMedioPago == ordenObj.idCatMedioPago)?.vMedioPago || "Sin Especificar"}
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-500 fs--2 fw-semi-bold mb-1">Cuenta Bancaria</div>
                                    <div className="fw-bold text-dark d-flex align-items-center gap-2 fs--1">
                                        {CargandoModalConciliar ? <Skeleton /> : (() => {
                                            const c = cuentas.find(c => c.idCatCuentaBancaria == ordenObj.idCatCuentaBancaria);
                                            return (
                                                <>
                                                    <FontAwesomeIcon icon={icon({ name: 'building-columns', style: "solid" })} className="text-400 fs-1" />
                                                    {c ? `[${c.vNumCta}] [${c.vNombreBanco}] ${c.vAlias}` : "Sin Especificar"}
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        /* EDICIÓN MODE */
                        <>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Moneda</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <Form.Select
                                                className="form-control border shadow-none"
                                                value={monedaEditada}
                                                onChange={(e) => setMonedaEditada(e.target.value)}
                                            >
                                                {monedas.map((m, i) => <option key={i} value={m.vClaveMoneda}>{m.vClaveMoneda}</option>)}
                                            </Form.Select>
                                        }
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Medio de Pago</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <Form.Select
                                                className="form-control border shadow-none"
                                                value={Modal_idCatMedioPago}
                                                onChange={(e) => setModal_idCatMedioPago(e.target.value)}
                                            >
                                                <option value="0">Sin medio de pago</option>
                                                {mediosPago.map((mp, i) => <option key={i} value={mp.idCatMedioPago}>{mp.vMedioPago}</option>)}
                                            </Form.Select>
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>
                            {monedaEditada != "MXN" && (
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Tipo de Cambio</Form.Label>
                                            <CurrencyInput
                                                className="form-control border shadow-none"
                                                defaultValue={ordenObj.dTipoCambio}
                                                decimalsLimit={4}
                                                prefix="$ "
                                                onValueChange={(value) => setModal_dTipoCambio(value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Forma de Pago</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <Form.Select
                                                className="form-control border shadow-none"
                                                value={Modal_idCatFormaPago}
                                                onChange={(e) => {
                                                    const selectedValue = e.target.value;
                                                    setModal_idCatFormaPago(selectedValue);
                                                    setOrdenObj({
                                                        ...ordenObj,
                                                        objDataExtra: {
                                                            ...ordenObj.objDataExtra,
                                                            vCardType: selectedValue === "4" ? 'credit' : selectedValue === "18" ? 'debit' : ''
                                                        }
                                                    });
                                                }}
                                            >
                                                <option value="0">Sin especificar</option>
                                                {formasPago.map((fp, i) => <option key={i} value={fp.idCatFormaPago}>{fp.idCatFormaPago} - [{fp.vClave}] {fp.vDescripcionFormaPago}</option>)}
                                            </Form.Select>
                                        }
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Cuenta Bancaria</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <Form.Select
                                                className="form-control border shadow-none"
                                                value={Modal_idCatCuentaBancaria}
                                                onChange={(e) => setModal_idCatCuentaBancaria(e.target.value)}
                                            >
                                                <option value="0">Sin cuenta bancaria</option>
                                                {cuentas.map((c, i) => <option key={i} value={c.idCatCuentaBancaria}>[{c.vNumCta}] [{c.vNombreBanco}] {c.vAlias}</option>)}
                                            </Form.Select>
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    {(parseInt(Modal_idCatFormaPago) === 4 || parseInt(Modal_idCatFormaPago) === 18) && (
                                        <Form.Group>
                                            <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Compañía de la tarjeta</Form.Label>
                                            {CargandoModalConciliar ? <Skeleton height={38} /> :
                                                <div className="d-flex align-items-center gap-2">
                                                    <Form.Select
                                                        className="form-control border shadow-none w-100"
                                                        value={ordenObj.objDataExtra?.vCardCompany || ""}
                                                        onChange={(e) => setOrdenObj({ ...ordenObj, objDataExtra: { ...ordenObj.objDataExtra, vCardCompany: e.target.value } })}
                                                    >
                                                        <option value="">Sin especificar</option>
                                                        <option value="visa">Visa</option>
                                                        <option value="mastercard">MasterCard</option>
                                                    </Form.Select>
                                                    <FontAwesomeIcon icon={icon({ name: 'credit-card', style: "solid" })} className="text-primary fs-2" />
                                                </div>
                                            }
                                        </Form.Group>
                                    )}
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Fecha del Pago</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <DatePicker
                                                selected={FechaPago ? new Date(FechaPago) : null}
                                                onChange={(date) => setFechaPago(date)}
                                                className="form-control border shadow-none w-100"
                                                dateFormat="MMMM d, yyyy"
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                            />
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 text-600 fw-semi-bold mb-1">Referencia</Form.Label>
                                        {CargandoModalConciliar ? <Skeleton height={38} /> :
                                            <Form.Control
                                                className="border shadow-none"
                                                value={Modal_vReferencia}
                                                onChange={(e) => setModal_vReferencia(e.target.value.toUpperCase())}
                                            />
                                        }
                                    </Form.Group>
                                </Col>
                            </Row>



                        </>
                    )}

                    {/* Common Bottom Sections */}
                    {ordenObj.objDataExtra && (ordenObj.objDataExtra.vClientName || ordenObj.objDataExtra.vBank || ordenObj.objDataExtra.vLastFourCardDigits) && (
                        <Card className="bg-light border-0 mb-3 shadow-none">
                            <Card.Body className="p-3 text-center">
                                <h6 className="text-600 fw-bold fs--2 text-uppercase mb-1">Datos Extras del Pago</h6>
                                <div className="text-500 fw-semi-bold fs--1">
                                    {`Cliente: ${ordenObj.objDataExtra.vClientName || 'N/A'} | Banco: ${ordenObj.objDataExtra.vBank || 'N/A'} | ${ordenObj.objDataExtra.vLastFourCardDigits ? `Tarjeta terminación: ${ordenObj.objDataExtra.vLastFourCardDigits}` : 'Sin tarjeta'}`}
                                </div>
                            </Card.Body>
                        </Card>
                    )}
                    <Card className="bg-light border-0 mb-3 shadow-none">
                        <Card.Body className="p-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <FontAwesomeIcon icon={icon({ name: 'clipboard-list', style: "solid" })} className="text-500" />
                                <span className="fw-semi-bold fs--1 text-dark text-uppercase">Notas Internas</span>
                            </div>
                            {!StateEditarModal ? (
                                <p className="mb-0 text-500 fs--1 fst-italic">
                                    {ordenObj.vNotasConciliacion || "No hay notas registradas para este pago."}
                                </p>
                            ) : (
                                <div>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        className="bg-white border shadow-none"
                                        placeholder="Agregar notas sobre la conciliación o discrepancias..."
                                        value={NotasInputText}
                                        onChange={(e) => setNotasInputText(e.target.value.toUpperCase())}
                                        maxLength={250}
                                        autoComplete="off"
                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase(); setNotasInputText(event.target.value); }}
                                    />
                                    <div className="text-end text-500 fs--2 mt-1">{NotasInputText.length} / 250 caracteres</div>
                                </div>
                            )}
                        </Card.Body>
                    </Card>


                </Modal.Body>

                <Modal.Footer className="justify-content-between border-top-0 pt-0">
                    <div className="d-flex gap-2">
                        <Button variant="outline-secondary" className="px-4 fw-semi-bold border-200" onClick={() => { setShowModalConciliar(false); reset() }}>
                            Cerrar
                        </Button>
                    </div>
                    <div className="d-flex gap-2">
                        {StateEditarModal && (
                            <Button variant="primary" size="sm" className="px-3 fw-bold shadow-sm d-flex align-items-center gap-2" onClick={() => { handdleEditarPago(monedaEditada, Modal_dTipoCambio, Modal_idCatMedioPago, Modal_idCatFormaPago, Modal_idCatCuentaBancaria, FechaPago, Modal_vReferencia); }}>
                                <FontAwesomeIcon icon={icon({ name: 'floppy-disk', style: "solid" })} /> Guardar Cambios
                            </Button>
                        )}
                        {ordenObj.bIsActive == 1 && idCatTipoUsuario == 1 && !EsConciliado && !CargandoModalConciliar && !StateEditarModal && (
                            <Button variant="success" className="px-4 fw-semi-bold d-flex align-items-center gap-2 shadow-sm" onClick={() => { onSubmitConciliacion("1"); }}>
                                <FontAwesomeIcon icon={icon({ name: 'circle-check', style: "regular" })} /> Conciliar
                            </Button>
                        )}
                    </div>
                </Modal.Footer>
            </Form>

            {/* Cancelation Modal */}
            <Modal
                show={showCancelarPagoModal}
                onHide={() => setShowCancelarPagoModal(false)}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancelar Pago</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>¿Cuál es el motivo por el que deseas cancelar el pago <strong>#{ordenObj.idPago}</strong>?</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={motivoCancelacionPago}
                            onChange={(e) => setMotivoCancelacionPago(e.target.value)}
                            placeholder="Escribe el motivo aquí..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCancelarPagoModal(false)} disabled={procesandoCancelacion}>
                        Cerrar
                    </Button>
                    <Button variant="danger" onClick={confirmarCancelacionPago} disabled={procesandoCancelacion}>
                        {procesandoCancelacion ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        ) : null}
                        Confirmar Cancelación
                    </Button>
                </Modal.Footer>
            </Modal>
        </Modal>
    )
};

ModalConciliarPago.propTypes = {
    showModalConciliar: PropTypes.bool.isRequired,
    setShowModalConciliar: PropTypes.func.isRequired,
    idPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onPagoActualizado: PropTypes.func
};

export default ModalConciliarPago;
